// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";

type PublicationInformationType = {
  title: string;
};

const PublicationInformation = ({ title }: PublicationInformationType) => {
  const { t } = useTranslation("operating-manual");

  const disclaimers = [
    "The Operating Manual is subject to periodic revisions and updates. The accuracy or completeness of the product information in the Operating Manual is subject to change. Users will be notified regarding any updates to the Operating Manual and will be provided with an up-to-date copy.",
    "If the provided product is defective, do not use, and do not try to repair the product or any of its parts. Only follow the written instructions provided in this Operating Manual.",
    "The user of the product has the sole responsibility for any malfunction that results from improper use, faulty maintenance, improper repair, and unauthorized service.",
  ];

  return (
    <OperatingManualContent title={title}>
      <Typography>
        {t(
          "The information in this manual only applies to the latest available version of the RVF200."
        )}
      </Typography>

      <Typography>
        {t(
          "RetinaLogik and RVF200 are trademarks owned by RetinaLogik Inc. All other marks are the properties of their respective owners."
        )}
      </Typography>

      <Box
        id="disclaimers"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          my: "20px",
          mx: "20px",
        }}
      >
        <Typography fontSize="16px" fontWeight={600}>
          {t("Disclaimers")}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            mx: "20px",
          }}
        >
          {disclaimers.map((disclaimer, index) => (
            <Typography key={`disclaimer-${index}`}>
              {index + 1}. {t(disclaimer)}
            </Typography>
          ))}
        </Box>
      </Box>

      <Typography>
        {t(
          "This document is protected by copyright. If not expressly approved in writing, the transmission, duplication, or other use or disclosure of this document's content is prohibited. RetinaLogik Inc. reserves the right to make changes due to further technical developments."
        )}
      </Typography>
    </OperatingManualContent>
  );
};

export default PublicationInformation;
